
import $ from "jquery"
import Slideout from "slideout"
import BS3_Dropdown from "components/bootstrap3-like-dropdown"

const SLIDEOUT_MENU_SELECTOR = "#main-navbar-menu--slideout"

const init_slideout = () => {
  const $slideout_menu = $(SLIDEOUT_MENU_SELECTOR)

  if ($slideout_menu.length === 0){
    return
  }

  const $page_container = $("#page-container")

  if ($page_container.length !== 1){
    return
  }

  const $backdrops = $(".main-navbar-mobile-backdrop, .main-navbar__mobile-backdrop")

  if ($backdrops.length === 0){
    return
  }

  const page_container_el = document.getElementById("page-container")
  const main_navbar_menu_slideout_el = document.getElementById("main-navbar-menu--slideout")

  if (page_container_el == null || main_navbar_menu_slideout_el == null) {
    return
  }

  const slideout = new Slideout({
    panel:      page_container_el,
    menu:       main_navbar_menu_slideout_el,
    padding:    280,
    tolerance:  70,
    side:       "right",

    // temporary fix for broken existing animation when swiping left
    touch:      false,
  })

  $(".js-slideout-toggle").on("click", () => {
    slideout.toggle()
  })

  BS3_Dropdown.init({
    scope:              SLIDEOUT_MENU_SELECTOR,
    dropdown_toggle:    ".dropdown-toggle",
    dropdown_container: ".dropdown",
  })

  $slideout_menu.find(".navbar-close-button").on("click", () => {
    slideout.close()
  })

  slideout.on("open", () => {
    $page_container.addClass("slideout-panel-right")
    $page_container.addClass("page--main-navbar-mobile-backdrop-enabled")
  })

  slideout.on("close", () => {
    $page_container.removeClass("slideout-panel-right")
    $page_container.removeClass("page--main-navbar-mobile-backdrop-enabled")
  })

  $backdrops.on("click", () => {
    slideout.close()
  })
}

const init = () => {
  init_slideout()
}


export default {
  init: init,
}
